export default [
  {
    name: "TeamStatus",
    path: "/manage/tour/TeamStatus",
    component: (resolve) => require(["./modules/TeamStatus.vue"], resolve),
  },
  {
    name: "dashboard",
    children: [
      {
        name: "orderList",
        path: "/manage/:service?/order/list/:state?",
        component: (resolve) => require(["./order/List.vue"], resolve),
      },
      {
        name: "orderDetail",
        path: "/manage/:service?/order/detail",
        component: (resolve) => require(["./order/detail.vue"], resolve),
      },
      {
        name: "amendList",
        path: "/manage/:service?/amend/list/:state?",
        component: (resolve) => require(["./amend/list.vue"], resolve),
      },
      {
        name: "amendDetail",
        path: "/manage/:service?/amend/detail",
        component: (resolve) => require(["./amend/detail.vue"], resolve),
      },

      {
        name: "policyList",
        path: "/manage/:service/policy/list/:state?",
        component: (resolve) => require(["./policy/list.vue"], resolve),
      },

      // {
      //     name: 'editTourPolicy',
      //     path: '/manage/train/policy/editPolicy',
      //     component: resolve => require(['./policy/editTourPolicy.vue'], resolve)
      // },
      //大客户名单
      {
        name: "ClientUserList",
        path: "/manage/flight/clientuser/list",
        component: (resolve) => require(["./clientuser/list.vue"], resolve),
      },
      //大客户协议
      {
        name: "ClientCodeList",
        path: "/manage/flight/clientcode/list",
        component: (resolve) => require(["./clientcode/list.vue"], resolve),
      },
      {
        name: "ClientUserUpdate",
        path: "/manage/flight/clientuser/update",
        component: (resolve) => require(["./clientuser/update.vue"], resolve),
      },
      {
        name: "ClientCodeUpdate",
        path: "/manage/flight/clientcode/update",
        component: (resolve) => require(["./clientcode/update.vue"], resolve),
      },
            {
        name:'flightchangelist',
        path:"/manage/:service?/flightchangelist",
        component:(resolve)=> require(["./flightchangeSms/list.vue"],resolve)
      },{
        name:'flightsmssettinglist',
        path:'/manage/flight/flightsmssettinglist',
        component:(resolve)=>require(['./flightchangeSms/listsetting.vue'],resolve)
      },
      {
        name:'baggageList',
        path:'/manage/flight/flightbaggagelist',
        component:(resolve)=>require(['./flight/baggage/list.vue'],resolve)
      },
      {
        name:'flightbagupdate',
        path:'/manage/flight/flightbaggageupdate',
        component:(resolve)=>require(['./flight/baggage/update.vue'],resolve)
      }
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/manage/router.js